import { AdditionalMenu } from 'common/components/AdditionalMenu';
import MenuItem, { MenuItemProps } from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { isEmpty } from 'lodash';

export type HeaderActionDef = {
  enabled?: boolean | (() => boolean);
  icon?: React.ReactNode;
  label: string;
  slotProps?: {
    menuItem: MenuItemProps;
  };
  actionCallback?: () => void;
};

export type ActionCellProps = {
  actions: HeaderActionDef[];
};

export const HeaderActionCell = ({ actions }: ActionCellProps) => {
  const enabledActions = actions.filter((action: any) => {
    let result;
    if (typeof action.enabled === 'function') {
      result = action.enabled();
    } else {
      result = action.enabled;
    }
    // != -> used here becuase only for false value we want false for others ex. undefiend need true
    // eslint-disable-next-line eqeqeq
    return result != false;
  });

  return isEmpty(enabledActions) ? null : (
    <AdditionalMenu>
      {({ onClose }) => (
        <>
          {enabledActions.map((action: any, index) => {
            return (
              <MenuItem
                key={action.id || index}
                {...action.slotProps?.menuItem}
                onClick={() => {
                  action.actionCallback();
                  if (action.closable ?? true) {
                    onClose();
                  }
                }}
              >
                {action.icon ? <ListItemIcon>{action.icon}</ListItemIcon> : null}
                <ListItemText>{action.label}</ListItemText>
              </MenuItem>
            );
          })}
        </>
      )}
    </AdditionalMenu>
  );
};
